import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';


class Exam3emeRegional extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="danger">
            <h3>
              Examen régional pour le troisème année secondaire.
            </h3>
          </Alert>



                    <Badge variant="warning"><h4>جهة سوس ماسة</h4></Badge><br/><br/>
                    <Row>
                        <MyCard
                        title="Examen regional maths - 2015"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_sous/Exam-Corr-Regional-maths-3ere-college-sous-2015.pdf" />

                        <MyCard
                        title="Examen regional maths - 2016"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_sous/Exam-Corr-Regional-maths-3ere-college-sous-2016.pdf" />


                        <MyCard
                        title="Examen regional maths - 2017"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_sous/Exam-Corr-Regional-maths-3ere-college-sous-2017.pdf" />
                    </Row>


                    <hr/>




                    <Badge variant="warning"><h4>جهة الداخلة وادي الذهب</h4></Badge> <br/><br/>

                    <Row>
                        <MyCard
                        title="Examen regional maths - 2014"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_dakh/Exam-Corr-Regional-maths-3ere-college-dakhla-2014.pdf" />

                        <MyCard
                        title="Examen regional maths - 2016"
                         ty="Examen"
                         color1="#C0C0C0"
                         content=""
                         fileUrl="/documents/file/pdf/3/exam/regional/region_dakh/Exam-Corr-Regional-maths-3ere-college-dakhla-2016.pdf" />

                    </Row>




                    <hr/>
                    <Badge variant="warning"><h4>جهة الدار البيضاء سطات</h4></Badge><br/><br/>
                    <Row>
                        <MyCard
                        title="Examen regional maths - 2015"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_casa/Exam-Corr-Regional-maths-3ere-college-casa-2015.pdf" />

                        <MyCard
                        title="Examen regional maths - 2017"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_casa/Exam-Corr-Regional-maths-3ere-college-casa-2017.pdf" />


                        <MyCard
                        title="Examen regional maths - 2018"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_casa/Exam-Corr-Regional-maths-3ere-college-casa-2018.pdf" />
                    </Row>






                    <hr/>
                    <Badge variant="warning"><h4>جهة طنجة تطوان الحسيمة</h4></Badge><br/><br/>

                    <Row>
                        <MyCard
                        title="Examen regional maths - 2015"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_tang/Exam-Corr-Regional-maths-3ere-college-tanger-2014.pdf" />

                        <MyCard
                        title="Examen regional maths - 2015"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_tang/Exam-Corr-Regional-maths-3ere-college-tanger-2015.pdf" />


                        <MyCard
                        title="Examen regional maths - 2017"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_tang/Exam-Corr-Regional-maths-3ere-college-tanger-2017.pdf" />
                    </Row>

                    <hr/>
                    <Badge variant="warning"><h4>جهة الرباط سلا القنيطرة</h4></Badge><br/><br/>
                    <Row>
                        <MyCard
                        title="Examen regional maths - 2014"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_rabat/Exam-Corr-Regional-maths-3ere-college-rabat-2014.pdf" />

                        <MyCard
                        title="Examen regional maths - 2015"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_rabat/Exam-Corr-Regional-maths-3ere-college-rabat-2015.pdf" />


                        <MyCard
                        title="Examen regional maths - 2016"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_rabat/Exam-Corr-Regional-maths-3ere-college-rabat-2016.pdf" />
                    </Row>


                    <hr/>
                    <Badge variant="warning"><h4>جهة الشرق</h4></Badge><br/><br/>
                    <Row>
                        <MyCard
                        title="Examen regional maths - 2016"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_char/Exam-Corr-Regional-maths-3ere-college-charq-2016.pdf" />

                        <MyCard
                        title="Examen regional maths - 2017"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_char/Exam-Corr-Regional-maths-3ere-college-charq-2017.pdf" />


                        <MyCard
                        title="Examen regional maths - 2018"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_char/Exam-Corr-Regional-maths-3ere-college-charq-2018.pdf" />
                    </Row>

                    <hr/>
                    <Badge variant="warning"><h4>جهة كلميم واد نون</h4></Badge><br/><br/>
                    <Row>
                        <MyCard
                        title="Examen regional maths - 2015"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_gal/Exam-Corr-Regional-maths-3ere-college-guelmim-2015.pdf" />

                        <MyCard
                        title="Examen regional maths - 2016"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_gal/Exam-Corr-Regional-maths-3ere-college-guelmim-2016.pdf" />


                        <MyCard
                        title="Examen regional maths - 2018"
                        ty="Examen"
                        color1="#C0C0C0"
                        content=""
                        fileUrl="/documents/file/pdf/3/exam/regional/region_gal/Exam-Corr-Regional-maths-3ere-college-guelmim-2018.pdf" />
                    </Row>





      </div>
    );
  }
}

export default Exam3emeRegional;
